import { translate } from '../lib/i18n.js';

interface DepthSliderOptions {
  initial?: number;
  min?: number;
  max?: number;
  onChange?: (value: number) => void;
}

interface DepthSliderResult {
  el: HTMLElement;
  getValue: () => number;
  setValue: (v: number) => void;
  destroy: () => void;
}

export function createDepthSlider(container: HTMLElement, options: DepthSliderOptions = {}): DepthSliderResult {
  const { initial = 1, min = 1, max = 5, onChange } = options;

  const wrapper = document.createElement('div');
  wrapper.className = 'depth-slider';
  wrapper.innerHTML = `
    <label class="depth-slider__label">
      <span class="depth-slider__text">${translate('neighbor.depth', 'depth')}</span>
      <span class="depth-slider__value">${initial}</span>
    </label>
    <input type="range" class="depth-slider__input"
      min="${min}" max="${max}" step="1" value="${initial}">
  `;

  const input = wrapper.querySelector('input') as HTMLInputElement;
  const valueEl = wrapper.querySelector('.depth-slider__value') as HTMLElement;
  let debounceTimer: ReturnType<typeof setTimeout> | null = null;

  input.addEventListener('input', () => {
    const val = parseInt(input.value, 10);
    valueEl.textContent = String(val);
    if (onChange) {
      if (debounceTimer) clearTimeout(debounceTimer);
      debounceTimer = setTimeout(() => onChange(val), 200);
    }
  });

  container.appendChild(wrapper);

  return {
    el: wrapper,
    getValue() { return parseInt(input.value, 10); },
    setValue(v: number) {
      input.value = String(v);
      valueEl.textContent = String(v);
    },
    destroy() {
      if (debounceTimer) clearTimeout(debounceTimer);
      wrapper.remove();
    },
  };
}
